<template>
    <div>
        <HeadNav></HeadNav>
        <LeftMenu></LeftMenu>
        <div class="rightContainer">
          <router-view></router-view>
        </div>
        
    </div>
</template>

<script>
import HeadNav from '../components/HeadNav'
import LeftMenu from '../components/LeftMenu'
import EditPasswordDialog from '../components/EditPasswordDialog'

export default {
    name: "index",
    components: {
        HeadNav,
        LeftMenu,
    },
    created () {
      this.getProfile()
    },
    data(){
    return {
        
    }
},
    methods: {
      
      
      getProfile(){
        
        
      }
    }
};
</script>

<style scoped>
.index {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
/* 顶部导航固定 */
.head-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px; /* 假设高度为60px */
  background-color: #333; /* 你的顶部栏颜色 */
  z-index: 100; /* 确保在最上层 */
}

/* 右侧容器 */
.rightContainer {
  margin-left: 200px; /* 等于菜单宽度 */
  margin-top: 60px; /* 等于顶部导航高度 */
  min-height: calc(100vh - 60px);
  overflow-y: auto; /* 右侧内容独立滚动 */
  background-color: #fff; /* 右侧背景色 */
}
/* 左侧菜单固定 */
.menu_page {
  position: fixed;
  top: 60px; /* 等于顶部导航的高度 */
  left: 0;
  width: 200px; /* 你的菜单宽度 */
  height: calc(100vh - 60px); /* 高度 = 视口高度 - 顶部导航高度 */
  background-color: #222; /* 你的菜单背景色，覆盖白色 */
  overflow-y: auto; /* 菜单内部内容过多时，自身产生滚动条 */
  z-index: 99;
}
</style>

